import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function fetchUserCourses(fetchParams, requestKey, page, cacheGroupKey) {
  return standardApiRequestAction({
    path: '/api/v1/user_courses',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
    cacheGroupKey,
  });
}

export function fetchCourseMembers({ course_id, ...fetchParams }, requestKey, page) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${course_id}/users`,
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function addUserCourseEnrollment(courseId, fetchParams) {
  return standardApiRequestAction({
    method: 'post',
    path: '/api/v1/user_courses',
    body: { ...fetchParams, course_id: courseId },
  });
}

export function toggleIsPastCourse(ucId, toggle) {
  return standardApiRequestAction({
    method: 'patch',
    path: `/api/v1/user_courses/${ucId}/toggle_is_past`,
    body: { is_past: toggle },
    instantUpdate: { userCourses: [{ id: ucId, is_past: toggle }] },
  });
}
export function updateUserCourse(ucId, updates) {
  return standardApiRequestAction({
    method: 'patch',
    path: `/api/v1/user_courses/${ucId}`,
    body: { user_course: updates },
    instantUpdate: { userCourses: [{ id: ucId, ...updates }] },
  });
}

export function inviteCourseMembers(courseId, emails, fetchParams) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseId}/users/invite_members`,
    method: 'post',
    body: { emails, ...fetchParams },
  });
}

export function acceptCourseMemberInvite(ucId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${ucId}/accept_invite`,
    method: 'patch',
  });
}

export function deleteCourseMember(ucId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${ucId}`,
    method: 'delete',
    destroy: { userCourses: [ucId] },
  });
}

export function confirmCoursePurchase(courseId, paymentIntentId, opts, discountCodeId) {
  return standardApiRequestAction({
    path: `/api/v1/courses/${courseId}/users/confirm_purchase`,
    method: 'post',
    body: { payment_intent_id: paymentIntentId, discount_code_id: discountCodeId, opts },
  });
}

export function updateScheduleEventProgress(userCourseId, progressUpdate) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/update_schedule_event_progress`,
    method: 'put',
    body: { event_progress: progressUpdate },
  });
}

export function updatePrereqsProgress(userCourseId, prereqsProgress) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/update_prereqs_progress`,
    method: 'put',
    body: { prereqs_progress: prereqsProgress },
  });
}

export function fetchCourseProgressAnalytics(userCourseId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/progress_analytics`,
    requestKey,
  });
}

// Sdandardized Test Course

export function confirmStdTestCoursePurchase(courseSlug, paymentIntentId, affirmCheckoutToken, formData) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/confirm_std_test_course_purchase/${courseSlug}`,
    method: 'post',
    body: { payment_intent_id: paymentIntentId, affirm_checkout_token: affirmCheckoutToken, form_data: formData },
  });
}

// MCAT

export function confirmMCATPurchase(paymentIntentId, affirmCheckoutToken, formData) {
  return standardApiRequestAction({
    path: '/api/v1/user_courses/confirm_mcat_purchase',
    method: 'post',
    body: { payment_intent_id: paymentIntentId, affirm_checkout_token: affirmCheckoutToken, form_data: formData },
  });
}

export function fetchWebTextbookVersions(userCourseId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/web_textbook_versions`,
    requestKey,
  });
}

export function updateMCATPracticeTestResult(userCourseId, practiceTestResult) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/update_mcat_practice_test_result`,
    method: 'put',
    body: { test_result: practiceTestResult },
  });
}

export function updateUserCourseMcatEliteInfo(userCourseId, updates) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/update_mcat_elite_info`,
    method: 'patch',
    body: updates,
  });
}

// LSAT

export function confirmLSATPurchase(paymentIntentId, affirmCheckoutToken, formData) {
  return standardApiRequestAction({
    path: '/api/v1/user_courses/confirm_lsat_purchase',
    method: 'post',
    body: { payment_intent_id: paymentIntentId, affirm_checkout_token: affirmCheckoutToken, form_data: formData },
  });
}

// SAT / ACT

export function createUserScoresmartAccount(userCourseId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/create_scoresmart_account`,
    method: 'post',
  });
}

// DAT

export function confirmDATPurchase(paymentIntentId, affirmCheckoutToken, formData) {
  return standardApiRequestAction({
    path: '/api/v1/user_courses/confirm_dat_purchase',
    method: 'post',
    body: { payment_intent_id: paymentIntentId, affirm_checkout_token: affirmCheckoutToken, form_data: formData },
  });
}

export function updateUserCourseLsacInfo(userCourseId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/update_lsac_info`,
    method: 'patch',
  });
}
export function activateUserCourseLsacCoaching(userCourseId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/activate_lsac_coaching`,
    method: 'post',
  });
}

export function upgradeUserCourseLsacSubscription(userCourseId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/upgrade_lsac_subscription`,
    method: 'put',
  });
}

// ADMIN

export function fetchStandardTestCourseUserCourses(fetchParams, requestKey, page, cacheGroupKey) {
  return standardApiRequestAction({
    path: '/api/v1/user_courses/std_test_course_user_courses',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
    cacheGroupKey,
  });
}

// Standardized admin add-student for MCAT/LSAT/DAT
export function addStandardTestCoursePurchase(params) {
  return standardApiRequestAction({
    path: '/api/v1/user_courses/std_test_course_purchases',
    method: 'post',
    body: params,
  });
}

export function resyncVitriumBooklets() {
  return standardApiRequestAction({
    path: '/api/v1/user_courses/resync_vitrium_booklets',
    method: 'post',
  });
}

export function uploadMcatCodesSent({ code_type, file, force }) {
  return standardApiRequestAction({
    path: '/api/v1/user_courses/mcat_codes_sent_upload',
    method: 'postFormData',
    body: { code_type, file, force: force ? 'true' : 'false' },
  });
}

export function grantUserCourseFullAccess(id) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${id}/grant_full_access`,
    method: 'patch',
  });
}
export function removeUserCourseFullAccess(id) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${id}/remove_full_access`,
    method: 'patch',
  });
}
export function updateUserCourseSchedule(id, schedId, params) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${id}/update_schedule`,
    method: 'patch',
    body: { ...params, course_schedule_id: schedId },
  });
}

export function registerUserCourseAlternateScheduleEvents(id, schedId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${id}/register_alternate_schedule_events`,
    method: 'post',
    body: { course_schedule_id: schedId },
  });
}

export function fetchUserCourseResettableProgress(id) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${id}/resettable_progress`,
  });
}

export function resetUserCourseProgress(id, params) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${id}/reset_progress`,
    method: 'post',
    body: params,
  });
}

export function fetchSalesDemoOptions(userCourseId) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/sales_demo`,
  });
}

export function performSalesDemoAction(userCourseId, action, params) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/sales_demo/${action}`,
    method: 'post',
    body: params,
  });
}

export function fetchUserCourseAuditLogs(userCourseId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/user_courses/${userCourseId}/audit_logs`,
    requestKey,
  });
}
